import { View, Text, StyleSheet } from '@react-pdf/renderer'
import React from 'react'
import QRCodeComponent from './QRCode'

const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 15,
    left: 30,
    right: 30,
    borderTopWidth: 1.5,
    borderTopColor: '#000',
    paddingTop: 6,
    paddingBottom: 6,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 40,
  },
  footerTextContainer: {
    flex: 1,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  footerTextBold: {
    fontWeight: 'bold',
    marginBottom: 2,
    fontSize: 9,
    color: '#000',
  },
  footerText: {
    fontSize: 9,
    color: '#000',
  },
  qrCodeContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 10,
  }
})

interface FooterOfPDFProps {
  qrCodeDataUrl?: string
  qrCodeValue?: string
}

const FooterOfPDF: React.FC<FooterOfPDFProps> = ({ qrCodeDataUrl, qrCodeValue }) => {
  return (
    <View fixed style={styles.footer} >
      <View style={styles.footerTextContainer}>
        <Text style={styles.footerTextBold}>DUSTRE COMÉRCIO E FABRICAÇÃO DE LIGAS ESPECIAIS LTDA.</Text>
        <Text style={styles.footerText}>Av. Dr. Mauro Lindemberg Monteiro, 1.259 | Jardim Santa Fé | 06278-010 | Osasco - SP | Brasil</Text>
      </View>
      {qrCodeDataUrl && qrCodeValue && (
        <View style={styles.qrCodeContainer}>
          <QRCodeComponent qrCodeDataUrl={qrCodeDataUrl} size={50} />
        </View>
      )}
    </View>
  )
}

export default FooterOfPDF